/**
 * Lesbare Bezeichnungen fuer die Aktionen im Protokoll. Uebersicht („Neu seit gestern“) und
 * Protokollseite lesen dieselben Begriffe; der technische Code bleibt im Protokoll sichtbar.
 */

export const AUDIT_ACTION_LABELS: Record<string, string> = {
  'dataset.create': 'Datensatz angelegt',
  'dataset.create.bundle': 'Datensatz angelegt',
  'dataset.update': 'Datensatz geändert',
  'dataset.archive': 'Datensatz archiviert',
  'dataset.deprecate': 'Datensatz zurückgezogen',
  'dataset.delete': 'Datensatz gelöscht',
  'dataset.upstream': 'Herkunft des Datensatzes eingetragen',
  'distribution.create': 'Distribution angelegt',
  'distribution.update': 'Distribution geändert',
  'data.object.put': 'Datei abgelegt',
  'data.object.delete': 'Datei gelöscht',
  'data.object.purge': 'Dateien bereinigt',
  'data.ingest': 'Daten eingelesen',
  'data.rows.replace': 'Daten ersetzt',
  'data.subscribe': 'Live-Daten abonniert',
  'source.create': 'Quelle angelegt',
  'source.update': 'Quelle aktualisiert',
  'source.delete': 'Quelle gelöscht',
  'harvest.run': 'Fremden Katalog geerntet',
  'harvest.source.create': 'Fremden Katalog eingebunden',
  'harvest.source.delete': 'Fremden Katalog entfernt',
  'provider.create': 'Vorlage für Quellen angelegt',
  'provider.update': 'Vorlage für Quellen geändert',
  'provider.delete': 'Vorlage für Quellen gelöscht',
  'widget.create': 'Auswertung erstellt',
  'widget.update': 'Auswertung geändert',
  'widget.delete': 'Auswertung gelöscht',
  'dashboard.create': 'Dashboard angelegt',
  'dashboard.update': 'Dashboard geändert',
  'dashboard.delete': 'Dashboard gelöscht',
  'dashboard.add_widget': 'Element zum Dashboard hinzugefügt',
  'dashboard.remove_widget': 'Element vom Dashboard entfernt',
  'derivation.create': 'Abgeleiteten Datensatz angelegt',
  'derivation.update': 'Abgeleiteten Datensatz geändert',
  'derivation.refresh': 'Abgeleiteten Datensatz neu berechnet',
  'derivation.delete': 'Abgeleiteten Datensatz gelöscht',
  'alert_rule.create': 'Meldungsregel angelegt',
  'alert_rule.delete': 'Meldungsregel gelöscht',
  'alert_event.acknowledge': 'Meldung bestätigt',
  'publisher.create': 'Herausgeber angelegt',
  'publisher.delete': 'Herausgeber gelöscht',
  'data_service.create': 'Datendienst eingetragen',
  'data_service.delete': 'Datendienst entfernt',
  'map_service.create': 'Kartendienst eingebunden',
  'tenant.update': 'Angaben der Kommune geändert',
  'tenant.gebiet.add': 'Gemeinde zum Gebiet hinzugefügt',
  'tenant.gebiet.remove': 'Gemeinde aus dem Gebiet entfernt',
  'tenant.hero.update': 'Titelbild geändert',
  'tenant.hero.remove': 'Titelbild entfernt',
  'system.restart_requested': 'Dienst neu gestartet',
  'link_tile.create': 'Link-Kachel angelegt',
  'link_tile.delete': 'Link-Kachel gelöscht',
  'llm.provider.create': 'KI-Anbieter angelegt',
  'llm.provider.update': 'KI-Anbieter geändert',
  'llm.provider.delete': 'KI-Anbieter gelöscht',
  'llm.provider.activate': 'KI-Anbieter aktiviert',
  'llm.api_key.set': 'KI-Schlüssel hinterlegt',
};

/** Lesbare Bezeichnung; unbekannte Aktionen bleiben beim technischen Code. */
export function auditLabel(action: string): string {
  return AUDIT_ACTION_LABELS[action] ?? action;
}

const ASSET_LABELS: Record<string, string> = {
  dataset: 'Datensatz',
  distribution: 'Distribution',
  source: 'Quelle',
  harvest_source: 'Fremder Katalog',
  data_provider: 'Vorlage',
  widget: 'Auswertung',
  dashboard: 'Dashboard',
  dashboard_widget: 'Dashboard-Element',
  derivation: 'Abgeleiteter Datensatz',
  alert_rule: 'Meldungsregel',
  alert_event: 'Meldung',
  publisher: 'Herausgeber',
  data_service: 'Datendienst',
  tenant: 'Kommune',
  organisation: 'Gliederung',
  tenant_setting: 'Einstellung',
  service: 'Dienst',
  link_tile: 'Link-Kachel',
  llm_provider: 'KI-Anbieter',
};

/** Objekt eines Eintrags fuer die Tabelle, z. B. „Datensatz · 3f2a91c0“; ohne Kennung nur die Art. */
export function auditAsset(type: string | null, id: string | null): string {
  if (!type) return '—';
  const kind = ASSET_LABELS[type] ?? type;
  return id ? `${kind} · ${id.slice(0, 8)}` : kind;
}
